module.exports = __webpack_public_path__ + "static/img/MMC_Gimbal_Z40S.90727df2.png";